import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { TicketTypes } from './MaintenanceEmptyState';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { formatMonthDay } from '@/utils/residents/maintenance/maintenance';
import { formatRelativeDate } from '@/utils/common/formatting';

interface MaintenanceDateLabelProps {
  ticketType: TicketTypes;
  id?: number;
  createdOn?: string;
  updatedOn?: string;
  completedOn?: string;
}

export const MaintenanceDateLabel: React.FC<MaintenanceDateLabelProps> = ({
  ticketType,
  createdOn,
  updatedOn,
  completedOn,
}) => {
  if (ticketType === TicketTypes.OPEN) {
    return (
      <View style={styles.openPill}>
        <Text style={styles.openPillText}>{`Updated ${formatRelativeDate(updatedOn || createdOn)}`}</Text>
      </View>
    );
  }
  return (
    <View style={styles.completedPill}>
      <View style={styles.completedRow}>        
        <RESIDENTS_SVG_COMPONENTS.CHECK width={12} height={12} />
        <Text style={styles.completedPillText}>{`Completed ${formatMonthDay(completedOn)}`}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  openPill: {
    borderRadius: 999,
    backgroundColor: '#57534e', // stone-600
    alignSelf: 'flex-start',
    marginBottom: 4,
  },
  openPillText: {
    fontSize: 12,
    color: '#ffffff',
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
  completedPill: {
    borderRadius: 999,
    backgroundColor: 'rgba(134, 239, 172, 0.1)', // green-300 @ 10%
    alignSelf: 'flex-start',
    marginBottom: 4,
  },
  completedRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  completedPillText: {
    fontSize: 12,
    color: '#86efac', // green-300
    paddingHorizontal: 8,
    paddingVertical: 2,
  },
});

export default MaintenanceDateLabel;


